import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const BASE_URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(BASE_URL);

export function login(username, password) {
    return axios.post('/rest-auth/login/', {
        username,
        password
    });
}

export function logout() {
    return axios.post('/rest-auth/logout/');
}

export function register(data) {
    return axios.post(
        `/rest-auth/registration/${data.referalId ? '?referal_id=' + data.referalId : ''}`,
        data
    );
}

export function refreshToken(token) {
    return axios.post('/api/token/refresh/', {
        token
    });
}

export function requestResetPassword(email) {
    const host = `${location.protocol}//${location.host}`;
    return axios.post('/rest-auth/password/reset/', {
        email,
        front_host: host
    });
}

export function resetPassword(data) {
    return axios.post('/rest-auth/password/reset/confirm/', {
        ...data
    });
}

export function changePassword(data) {
    return axios.post('/rest-auth/password/change/', data);
}

export function fetchResetPasswordHelpText() {
    return axios.get('/rest-auth/password/help_text/');
}

export function fetchUser() {
    return axios.get('/rest-auth/user/');
}

// @TODO MOVE THIS TO BOOK MODULE
export function fetchUserAuthors() {
    return axios.get('/api/v1/authors/?page_size=9999');
}

export function updateAuthor(authorId, data) {
    return axios.patch(`/api/v1/authors/${authorId}/`, data);
}

export function lockUserCurrency(currency) {
    return axios.patch('/rest-auth/user/', { currency, blocked_currency: true });
}

export function fetchHelpText() {
    return axios.get('/rest-auth/password/help_text/');
}

export function updateUser(data) {
    return axios.patch('/rest-auth/user/', data);
}

export function addAuthors(data) {
    return axios.post('/api/v1/authors/', data);
}

export function updateAuthors(id, data) {
    return axios.patch(`/api/v1/authors/${id}/`, data);
}

export function exportUsers() {
    return axios.get('/api/v1/users/export/', {
        responseType: 'blob'
    });
}
